import { Skeleton } from "@/components/ui/skeleton";

const cards = [
  { key: "total", title: "Total Users", field: "total_users", dot: "#572B7C" },
  { key: "pending", title: "Pending", field: "pending_users", dot: "#B45309" },
  { key: "approved", title: "Approved", field: "approved_users", dot: "#15803D" },
];

const UsersHeader = ({ stats, loading }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-[13px]">
    {loading
      ? Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-[78px] rounded-[14px]" />)
      : cards.map((c) => (
          <div key={c.key} className="sz-card sz-card-hover px-4 py-[15px]">
            <div className="flex items-center gap-[9px]">
              <span className="w-[9px] h-[9px] rounded-[3px] shrink-0" style={{ background: c.dot }} />
              <span className="text-xs font-semibold text-[#8A90A2]">{c.title}</span>
            </div>
            <div className="sz-stat-num mt-2 text-[#0C1120]">
              {(stats[c.field] ?? 0).toLocaleString()}
            </div>
          </div>
        ))}
  </div>
);

export default UsersHeader;
